import { useEffect } from 'react'
import { startChatApplication } from 'utils/chat-app/startChatApplication'
import type { UserState } from 'utils/hooks/use-userInfo'

type Props = {
  user: UserState
}

export default function ChatApp({ user }: Props) {
  useEffect(() => {
    if (!user) {
      return
    }

    if (global.webViewActive && window.ReactNativeWebView) {
      return
    }

    startChatApplication(user)
  }, [user])

  return null
}
